const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8Plus3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 24,
    y1: 6.5,
    x2: 24,
    y2: 41.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 41.5,
    y1: 24,
    x2: 6.5,
    y2: 24
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Plus3);
export default __webpack_public_path__ + "static/media/icons8-plus (3).1edc243700ec0e5ae47a5d9a8b800022.svg";
export { ForwardRef as ReactComponent };